module.exports = __webpack_public_path__ + "static/media/bullet.03322fee.svg";